
import 'firebase/compat/functions'; // removed in build process when not UMD

export * from './functions';
export * from './functions.module';
